import { Converter } from '../types/converter';

export const temperatureIntervalConverter: Converter = {
  id: 'temperatureInterval',
  name: 'Temperature Interval Converter',
  icon: 'Thermometer',
  categories: ['common', 'engineering', 'heat'],
  units: [
    // Base unit
    { name: 'Kelvin', symbol: 'K', factor: 1 },
    
    // Common temperature interval units
    { name: 'Degree Celsius', symbol: '°C', factor: 1 },
    { name: 'Degree Centigrade', symbol: '°C (cent)', factor: 1 },  // Changed symbol to avoid duplicate
    { name: 'Degree Fahrenheit', symbol: '°F', factor: 5/9 },
    { name: 'Degree Rankine', symbol: '°R', factor: 5/9 },
    { name: 'Degree Reaumur', symbol: '°r', factor: 1.25 }
  ]
};
